import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
// Google reCAPTCHA site key (you'll need to replace this with your actual site key)
const RECAPTCHA_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; // This is a test key
export function TrialOfferCTA() {
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
  useEffect(() => {
    // Load reCAPTCHA script if not already loaded
    if (!document.querySelector('script[src*="recaptcha"]')) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js`;
      script.async = true;
      script.defer = true;
      script.onload = () => setRecaptchaLoaded(true);
      document.body.appendChild(script);
    } else {
      setRecaptchaLoaded(true);
    }
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Get reCAPTCHA response
    const recaptchaResponse = (window as any).grecaptcha?.getResponse();
    if (!recaptchaResponse) {
      alert('Please complete the reCAPTCHA verification');
      return;
    }
    console.log('Form submitted with reCAPTCHA:', recaptchaResponse);
    // Handle form submission here
  };
  return <section className="py-20 px-4 bg-gray-50" data-id="element-181">
      <div className="max-w-5xl mx-auto" data-id="element-182">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-183">
          <div className="bg-white rounded-2xl overflow-hidden shadow-2xl border-2 border-[#a3d977]/30" data-id="element-184">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-185">
              {/* Left Side - Offer Details */}
              <div className="p-8 md:p-12 bg-[#0f1f3d] text-white flex flex-col justify-center" data-id="element-186">
                <div className="inline-block px-3 py-1 bg-[#dc2626] text-xs font-bold uppercase tracking-wider rounded mb-4 w-fit border border-[#a3d977]/30" data-id="element-187">
                  Limited Time Offer
                </div>
                <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-188">
                  2 Weeks for Just $29
                </h2>
                <ul className="space-y-3 mb-8" data-id="element-189">
                  {['Unlimited classes for 2 weeks', 'Official uniform included (Free)', 'Personal intro session', 'No long-term commitment'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-190">
                      <CheckCircle2 className="w-5 h-5 text-[#a3d977] shrink-0" data-id="element-191" />
                      <span className="text-gray-200" data-id="element-192">{item}</span>
                    </li>)}
                </ul>
                <p className="text-sm text-gray-400 italic" data-id="element-193">
                  *Only 5 spots remaining for this month's intake
                </p>
              </div>

              {/* Right Side - Form */}
              <div className="bg-gray-50 p-8 md:p-12 flex flex-col justify-center" id="lead-form" data-id="element-194">
                <div className="text-center mb-6" data-id="element-195">
                  <h3 className="text-2xl font-bold text-[#0f1f3d]" data-id="element-196">
                    Claim Your Spot
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-197">
                    Fill out the form below to get started.
                  </p>
                </div>

                <form className="space-y-4" onSubmit={handleSubmit} data-id="element-198">
                  <div data-id="element-199">
                    <label htmlFor="name" className="sr-only" data-id="element-200">
                      Parent's Name
                    </label>
                    <input type="text" id="name" placeholder="Parent's Name" className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all" required data-id="element-201" />
                  </div>
                  <div data-id="element-202">
                    <label htmlFor="phone" className="sr-only" data-id="element-203">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" placeholder="Phone Number" className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all" required data-id="element-204" />
                  </div>
                  <div data-id="element-205">
                    <label htmlFor="childAge" className="sr-only" data-id="element-206">
                      Child's Age
                    </label>
                    <input type="number" id="childAge" placeholder="Child's Age" className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all" required data-id="element-207" />
                  </div>

                  {/* Google reCAPTCHA */}
                  <div className="flex justify-center" data-id="element-208">
                    <div className="g-recaptcha" data-sitekey={RECAPTCHA_SITE_KEY} data-id="element-209"></div>
                  </div>

                  <motion.button whileTap={{
                  scale: 0.98
                }} type="submit" className="w-full py-4 bg-[#dc2626] text-white font-bold rounded-lg shadow-md hover:bg-red-700 transition-colors text-lg border-2 border-[#a3d977]/30" data-id="element-210">
                    Get Started Now
                  </motion.button>
                </form>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}